// extracted by mini-css-extract-plugin
export default {"ComponentHolder":"TravelDetailModal_ComponentHolder__TYoRs"};